<div
  class="flex flex-row"
  [ngClass]="canClick && !fieldDef.meta?.value_hidden ? 'dotted-underline' : ''"
  (click)="clickField($event)"
>
  <div class="font-semibold mr-1" *ngIf="!excludeLabels">{{ fieldDef.label }}:</div>
  @if (fieldDef.meta?.value_hidden) {
    <div>{{ value }}</div>
  } @else {
    <div [ngClass]="{ underline: customObjType !== 'User' }" (click)="value && goToBaseRecord()">
      {{ value | readableField: value : fieldDef : value }}
    </div>
  }
</div>
